import { useState, useEffect } from 'react'
import axios from 'axios'

import { ExclusiveCountryCode, TranslatedCountryCode, HidePricesCountryCode } from '../constants/data/exclusive'

const useIsExclusive = () => {
  const [isExclusive, setIsExclusive] = useState(false)
  const [isTranslated, setIsTranslated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [countryCode, setCountryCode] = useState('')

  const shouldHidePrices = isExclusive || Object.keys(HidePricesCountryCode).includes(countryCode)

  const getExclusive = async () => {
    try {
      setIsLoading(true)

      const {
        data: { countryISOCode },
      } = await axios.get('https://www.1home.io/xapi/ip')

      if (Object.keys(ExclusiveCountryCode).includes(countryISOCode)) {
        setIsExclusive(true)
        setCountryCode(countryISOCode)
      }

      if (Object.keys(TranslatedCountryCode).includes(countryISOCode)) {
        setIsTranslated(true)
        setCountryCode(countryISOCode)
      }

      if (Object.keys(HidePricesCountryCode).includes(countryISOCode)) {
        setCountryCode(countryISOCode)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getExclusive()
  }, [])

  return { isExclusive, isTranslated, isLoading, shouldHidePrices, countryCode }
}

export default useIsExclusive
